import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react'

import {Menu} from '../_Menu'
import Header from '../Header';
import Footer from '../_Footer'
import DatePicker from "react-datepicker";
import Pagger from '../components/_Pagger';

import '../assets/css/clients.css'
import ClientRow from './_ClientRow';
import ClientDetails from './_ClientDetails';
import { Select } from 'antd';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { CustomerDetailsModel, CustomerFilterModel, Input } from '../models/superbit-api-models';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import { ViewMode } from './enums';
import { SimulatorModel } from '../models/SimulatorModel';
import { ClientPopup } from './_ClientPopup';
import { title } from 'process';
import ClientAddTreatmentPopup from './_ClientAddTreatmentPopup';
import ClientTreatmentTabConfigPopup from './_ClientTreatmentTabConfigPopup';
import ClientDocumentPopup from './documents/_ClientDocumentPopup';
import ClientPolicyEditPopup from './createPolicyManually/_ClientPolicyEdit';
// import { ClientAddTreatmentPopup } from './_ClientAddTreatmentPopup';
import { useSelector, useDispatch } from 'react-redux'
import LoginPopup from '../login/_LoginPopUp';
import MessegePopup from '../subscribers/popups/_MessegePopup';
import MessegePopupClient from './_MessegePopupClient';
import { RootState } from '../app-context/store';
import AddClaimPopup from '../sues/_AddClaimPopup';
import { LeadMessagePopup } from '../leads/_LeadMessagePopup';
import { set } from 'lodash';
import UploadDocumentPopUp from './documents/_UploadDocumentPopUp';
import { setFileDocumentsUrl } from '../app-context/filesSlice';
import { setClientsData } from '../app-context/clientsSlice';


const Clients = () => {

    const dispatch = useDispatch();
    // const count = useSelector((state: any) => state.counter.value)
    const userLogged = useSelector((state: any) => state.user.value)
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const [isAdmin, setIsAdmin] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [clients, setClients] = useState<any[]>([]);
    const [openTabs, setOpenTabs] = useState<any[]>([]);
    const [sellectedCustomerId, setSellectedCustomerId] = useState<string | null>(null);
    const [detailsMode, setMode] = useState<ViewMode>(ViewMode.VIEW)
    const [selectedTabData, setSelectedTabData] = useState<any | null>(null)
    const [timeoutId, setTimeoutId] = useState<number | any | null>(undefined);
    const [searchText, setSearchText] = useState<string | null>(null)
    const [searchProperty, setSearchProperty] = useState<string>('NONE');
    const [filter, setFilter] = useState<any>({
        filterSearch: {
            property: undefined,
            searchText: ''
        },
        page: 1
    });
    const [agents, setAgents] = useState<any[]>([])
    const [handlers, setHandlers] = useState<any[]>([])
    const [groups, setGroups] = useState<any[]>([])
    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    const [genders, setGenders] = useState<any[]>([])
    const [martialStatuses, setMartialStatuses] = useState<any[]>([])
    const [citiesList, setCitiesList] = useState<any[]>([]);
    const [showPopUp, setShowPopup] = useState<boolean>(false);
    const [showApprovePopup, setShowApprovePopup] = useState<boolean>(false);
    const [showAddClaimPopup, setShowAddClaimPopup] = useState<boolean>(false);
    const [messageContent, setMessageContent] = useState<string | null>(null)
    const [popUpContent, setPopUpContent] = useState<string>('');
    const [popUptitle, setPopUpTitle] = useState<string>('');
    const [customerIdForDelete, setCustomerIdForDelete] = useState<string | null>(null)

    
    // policies end

    // documents
    
    const [clientDocumentUrl, setClientDocumentUrl] = useState<string | null>(null)

    // docuuments end

    // treatments
    const [showAddTreatmentPopUp, setShowAddTreatmentPopup] = useState<boolean>(false);
    const [newTreatmentType, setNewTreatmentType] = useState<number>(0);
    const [showTreatmentConfigPopUp, setShowTreatmentConfigPopup] = useState<boolean>(false);
    const [message, setMessege] = useState<string>('');
    const [popupShow, setPopupShow] = useState<boolean>(false);

    // Get single from treatment tasks in client by redux store
    const popUpTreatmentModel = useSelector((state: RootState) => state.tasks.popUpTreatmentModel)
    const fileDocumentsUrl = useSelector((state: RootState) => state.files.fileDocumentsUrl)
    const clientsData = useSelector((state: RootState) => state.clientsSlice.clientsData)

    // for add claim popup
    const [dataForClaimAdd, setDataForClaimAdd] = useState<any>({})

    // const [showModelUploadDocument, setShowModelUploadDocument] = useState<any>({
    //     show: false,
    //     customerId: ''
    // });

    useEffect(()=>{
        init();
    },
    []);

    useEffect(() => {
        if (fileDocumentsUrl) {
            setClientDocumentUrl(fileDocumentsUrl);
            dispatch(setFileDocumentsUrl(null));
        }
    },[fileDocumentsUrl])

    useEffect(()=> {
        console.log('showAddTreatmentPopUp', showAddTreatmentPopUp)
        console.log('1111111111111111', 1111111111111111)
        console.log('useEffect popUpTreatmentModel', popUpTreatmentModel)
        if(popUpTreatmentModel && popUpTreatmentModel.type >= 0 ) {
            showAddTreatmentPopup(popUpTreatmentModel.type);
            showHideAddTreatmentPopup(popUpTreatmentModel.show)
        }
    }, [popUpTreatmentModel])

    // useEffect(()=>{
    //     console.log('Filter changed')
    //     if (filter.filterSearch) {
    //         // loadCustomers(filter);
    //     }
    // }, [filter])

    const init = async () => {
        setLoading(true);
        
        let loggedUserData: any = localStorage.getItem('loggedUser');
        if (loggedUserData) {
            let loggedUser = JSON.parse(loggedUserData);
            setIsAdmin(loggedUser.role == 0);
        }

        const savedTabsStr = localStorage.getItem('clientsOpenTabs');
        if (savedTabsStr) {
            updateOpenTabs(JSON.parse(savedTabsStr));
        }
        let res: any = null;
        
        if(clientsData && clientsData.customers  && clientsData.customers.length > 0) {
            res = clientsData;
        } else {
            res = await customerCardModel.getOptions()
            console.log('customerCardModel.getOptions', res);
            dispatch(setClientsData(res));
        }

        if (res) {
            const newPageConf = {
                pageSize: 50,
                currentPage: 1,
                totalItems: res.allRowsCounter
            }
            if (res.customers) {
                setClients(res.customers);
                newPageConf.totalItems = res.allRowsCounter;
            }
            if (res.groups) {
                const newGroups: any[] = [
                    {
                        id: '-1',
                        name: 'כל הקבוצות'
                    }
                ];
                res.groups.forEach((group: any) => {
                    newGroups.push(group);
                });
                setGroups(newGroups);
            }
            if (res.agents) {
                const newAgents: any[] = [
                    {
                        id: '-1',
                        fullName: 'כל הסוכנים'
                    }
                ];
                res.agents.forEach((group: any) => {
                    newAgents.push(group);
                });
                setAgents(newAgents);
            }
            if (res.handlers) {
                const newHandlers: any[] = [
                    {
                        id: '-1',
                        fullName: 'כל המטפלים'
                    }
                ];
                res.handlers.forEach((group: any) => {
                    newHandlers.push(group);
                });
                setHandlers(newHandlers);
            }

            
            const lastFilterStr = localStorage.getItem('lastClientsFilter');
            if (lastFilterStr) {
                const newFilter = JSON.parse(lastFilterStr);
                if (newFilter.group == '-1') {
                    newFilter.group = undefined;
                }
                if (newFilter.agent == '-1') {
                    newFilter.agent = undefined;
                }
                if (newFilter.handler == '-1') {
                    newFilter.handler = undefined;
                }
                setSearchText(newFilter.filterSearch.searchText);
                setSearchProperty(newFilter.filterSearch.property ? newFilter.filterSearch.property : 'NONE');
                setFilter(newFilter);
                loadCustomers(newFilter);
            } else {
                setPagerConf(newPageConf);
            }

        }
        setLoading(false);
        // }).finally(()=>{
        // });
        simulatorModel.getGenderTypes().then((res: any)=>{
            console.log('getAppDictionaryList Genders', res);
            const gendersList: any = [];
            Object.keys(res).forEach((key: string)=>{
                const gender = res[key];
                gendersList.push( {
                    label: gender.description,
                    value: gender.id.toString()
                })
            })
            console.log('getAppDictionaryList Genders', gendersList);
            setGenders(gendersList);
        })
        simulatorModel.getMaritalStatus().then((res: any)=>{
            console.log('getAppDictionaryList Martial Statuses', res);
            const maritalStatusesList: any = [];
            Object.keys(res).forEach((key: string)=>{
                const gender = res[key];
                maritalStatusesList.push( {
                    label: gender.description,
                    value: gender.id.toString()
                })
            })
            console.log('getAppDictionaryList Martial Statuses', maritalStatusesList);
            setMartialStatuses(maritalStatusesList);
            localStorage.setItem('clients_maritalStatuses', JSON.stringify(maritalStatusesList));
        })

        const insuranceCompaniesStorage = localStorage.getItem('insuranceCompanies');
        let insuranceCompaniesList: any[] = [];
        if (!insuranceCompaniesStorage || insuranceCompaniesStorage.length == 0) {
            simulatorModel.getInsuranceCompanies().then((res: any)=>{
                console.log('getInsuranceCompanies', res);
                const icTempDataKeys = Object.keys(res);
                icTempDataKeys.forEach((k: string) => {
                    insuranceCompaniesList.push({
                        value: res[k].description,
                        label: res[k].name
                    })
                })
                localStorage.setItem('insuranceCompanies', JSON.stringify(insuranceCompaniesList));
            })
        } 

        const cities = simulatorModel.getCitiesAutocomplete();
        cities.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);
        setCitiesList(cities);
    }

    const loadCustomers = async (filter?: any) => {
        setLoading(true);
        if (filter && filter.filterSearch && filter.filterSearch.searchText) {
            filter.filterSearch.searchText = filter.filterSearch.searchText.trim();
            localStorage.setItem('lastClientsFilter', JSON.stringify(filter));
        }
        customerCardModel.filter(filter).then((res: any)=>{
            //
            console.log(res);
            if (res && res.customers) {
                setClients(res.customers);
                const newPagerConf = pagerConf;
                newPagerConf.totalItems = res.allRowsCounter;
                newPagerConf.currentPage = filter.page;
                console.log('pagerConf', newPagerConf);
                setPagerConf(newPagerConf);
            }
        }).finally(()=>{
            setLoading(false);
        })
        
    }
    
    const emptyFunc = () => {}

    const updateTabEditData = async (tabId: string, data: any, mode: ViewMode) => {
        let openTabIndex = openTabs.findIndex((m: any) => m.id == tabId);
        if (openTabIndex >= 0) {
            if (tabId != data.id && data.id != '00000000-0000-0000-0000-000000000000') {
                closeTab(tabId);
                setTimeout(()=>{
                    showClientTab(data.id);
                }, 2000);
            } else {
                openTabs[openTabIndex].editData = data;
                if (!openTabs[openTabIndex].personalData) {
                    openTabs[openTabIndex].personalData = {};
                }
                openTabs[openTabIndex].personalData.customerData = data;
                openTabs[openTabIndex].mode = mode;
                // if(mode == ViewMode.VIEW) {
                //     openTabs[openTabIndex].personalData.customerData = data;                    
                // }
                updateOpenTabs(openTabs);
                console.log('updateTabEditData', tabId, data);
            }
        } else { if (tabId != data.id && data.id != '00000000-0000-0000-0000-000000000000') {
            showClientTab(data.id);
        }
        }
    }

    const refreshClientList = () =>{
        const newFilter = filter;
        setTimeout(()=>{
            loadCustomers(newFilter);
        }, 300)
    }
    
    const updateTabMode = (tabId: string, mode: ViewMode) => {
        let openTabIndex = openTabs.findIndex((m: any) => m.id == tabId);
        if (openTabIndex >= 0) {
            openTabs[openTabIndex].mode = mode;
            updateOpenTabs(openTabs);
            console.log('updateTabMode', tabId, mode);
        }
    }

    const changePage = (page: number) => {
        console.log('changePage', page);
        
        const newFilter = filter;
        newFilter.page = page > 1 ? page : 1;
        setFilter(newFilter);
        pagerConf.currentPage = page;
        setPagerConf(pagerConf);
        loadCustomers(newFilter);
    }

    const onRowSelect = (id: string) => {
        console.log('onRowSelect');
        // setSelectedTabData(1);
        showCustomer(id, ViewMode.VIEW);
        // showCustomer(id);
    }

    const deleteCustomer = (id: string) => {
        const req: Input = new Input({
            id: id
        })
        customerCardModel.deletePersonalData(req);
        // {id: '0000-0000-...'}
    }

    const onCustomerAction = async(action: string, id: string) => {
        console.log('onCustomerAction', action, id);
        switch (action) {
            case 'edit':
                showCustomer(id, ViewMode.EDIT);
                break;
            case 'delete':
                // showCustomer(id, ViewMode.EDIT);
                showApproveDelete('מחיקת לקוח', 'האם את/אתה בטוח/ה?')
                setCustomerIdForDelete(id);
                break;
        
            default:
                break;
        }
    }

    const showCustomer = async(id: string, mode: ViewMode = ViewMode.VIEW)=>{
        await setSellectedCustomerId(null);
        await setSelectedTabData(null);
        let tabContent = openTabs.find((m: any) => m.id == id);
        let viewMode: ViewMode = mode;
        if (tabContent) {
            viewMode = tabContent.mode;
        }
        
        if (!tabContent || (tabContent.mode != ViewMode.ADD && !tabContent.loaded)) {
            const tabIsExists = tabContent ? true : false;
            setLoading(true);
            const customerCardData = await customerCardModel.getCustomerCardDetails(id);
            if (customerCardData) {
                tabContent = {
                    type: 'editCustomer',
                    id: id,
                    title: customerCardData.personalData && customerCardData.personalData.customerData.fullName,
                    customerDocumentsTab: customerCardData.customerDocumentsTab,
                    customerSueTab: customerCardData.customerSueTab,
                    customerWhatsappTab: customerCardData.customerWhatsappTab,
                    offerTab: customerCardData.offerTab,
                    personalData: customerCardData.personalData,
                    policiesTab: customerCardData.policiesTab,
                    speakComTab: customerCardData.speakComTab,
                    treatmentsTab: customerCardData.treatmentsTab,
                    mode: viewMode,
                    loaded: true
                }
                if (tabIsExists) {
                    const tabIndex = openTabs.findIndex((m: any) => m.id == id);
                    if (tabIndex >= 0) {
                        openTabs[tabIndex] = tabContent;
                        viewMode = openTabs[tabIndex].mode;
                    }
                    // 
                } else {
                    openTabs.push(tabContent);
                }
                updateOpenTabs(openTabs);
                // setSellectedCustomerId(id);
                // setSelectedTabData(tabContent);
            }
            setLoading(false);
        }
        localStorage.removeItem(`treatmentsRelations-${id}`);
        setSellectedCustomerId(id);
        // tabContent.mode = viewMode;
        setSelectedTabData(tabContent);
    }

    const openNewCustomerTab = async () => {
        setLoading(true);
        const customerCardData = await getEmptyCustomerData();
        const id = (new Date).getTime().toString();
        const tabContent = {
            type: 'addCustomer',
            id: id,
            title: "לקוח חדש", // customerCardData.personalData.customerData.fullName,
            customerDocumentsTab: customerCardData.customerDocumentsTab,
            customerSueTab: customerCardData.customerSueTab,
            customerWhatsappTab: customerCardData.customerWhatsappTab,
            offerTab: customerCardData.offerTab,
            personalData: customerCardData.personalData,
            policiesTab: customerCardData.policiesTab,
            speakComTab: customerCardData.speakComTab,
            treatmentsTab: customerCardData.treatmentsTab,
            mode: ViewMode.ADD
        }
        openTabs.push(tabContent);
        updateOpenTabs(openTabs);
        setSellectedCustomerId(id);
        setSelectedTabData(tabContent);
        setLoading(false);
    }

    const updateOpenTabs = (tabs: any) => {
        setOpenTabs(tabs);
        const tabsForSave: any[] = [];
        tabs.forEach((tab: any) => {
            const tContent: any = {
                type: tab.type,
                title: tab.title,
                id: tab.id,
                mode: tab.mode,
                editData: tab.editData ? tab.editData : undefined,
                loaded: false
            }
            if (tab.editData && typeof tab.editData !== 'undefined') {
                tContent.editData = tab.editData;
            }
            tabsForSave.push(tContent);
        });

        localStorage.setItem('clientsOpenTabs', JSON.stringify(tabsForSave));
    }
    
    const getEmptyCustomerData = async() =>{
        const emptyCustomer = await customerCardModel.getEmptyCustomerData();
        return emptyCustomer;
    }
    
    const closeTab = (id: string, e?: Event) => {
        if (e) {
            e.preventDefault();
        }

        const currentTabs =  openTabs.filter((m: any) => m.id !== id);
        updateOpenTabs(currentTabs);
        if (sellectedCustomerId == id) {
            setSellectedCustomerId(null);
            setSelectedTabData(null);
        }
    }

    const showClientTab = (id: string) => {
        showCustomer(id);
    }

    const showClientSList = () => {
        setSellectedCustomerId(null);
    }

    const clearFilter = () =>{
        const newFilter = {
            filterSearch: {
                searchText: '',
                property: undefined
            },
            group: undefined,
            agent: undefined,
            handler: undefined,
            page: 1
        };
        localStorage.setItem('lastClientsFilter', JSON.stringify(newFilter));
        setSearchText('');
        setSearchProperty('NONE');
        setFilter(newFilter);
        loadCustomers(newFilter);
    }

    const setFilterParameter = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('setFilterParameter', value);
        const newFilter = filter;
        if (value == 'NONE') {
            newFilter.filterSearch.property = undefined;
        } else {
            newFilter.filterSearch.property = value;
        }
        setSearchProperty(value);
        setFilter(newFilter);

        if (newFilter.filterSearch.searchText !== '') {
            loadCustomers(newFilter);
        }
    }

    const setFilterGroup = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        const newFilter = filter;
        newFilter.group = value && value !== '0' && value !== '-1' ? value : undefined;
        setFilter(newFilter);
        loadCustomers(newFilter);
    }

    const setFilterAgent = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        const newFilter = filter;
        newFilter.agent = value && value !== '0' && value !== '-1' ? value : undefined;
        setFilter(newFilter);
        loadCustomers(newFilter);
    }

    const setFilterHandler = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        const newFilter = filter;
        newFilter.handler = value && value !== '0' && value !== '-1' ? value : undefined;
        setFilter(newFilter);
        loadCustomers(newFilter);
    }

    const handleSearchChange =  async (event:any) => {
        const newSearchText = event.target.value;
        setSearchText(newSearchText);
        console.log('handleSearchChange', timeoutId, newSearchText, event);
        const newFilter = filter;
        newFilter.filterSearch.searchText = newSearchText;
        newFilter.page = 1;
        setFilter(newFilter);
        clearTimeout(timeoutId);
        const newTimeoutId = setTimeout(() => {
            loadCustomers(filter);
        }, 1000);
        setTimeoutId(newTimeoutId);
    };

    const showHidePopup = (show: boolean) => {
        setShowPopup(show);
    }
    const showApproveDelete = (title: string, message: string) => {
        setPopUpTitle(title);
        setPopUpContent(message);
        setShowApprovePopup(true);
    }
    const hideApproveDelete = () => {
        setPopUpTitle('')
        setPopUpContent('');
        setShowApprovePopup(false);
    }
    
    const onShowAddClaimPopup = (id: string, data?: any) => {
        // console.log('onShowAddClaimPopup SueDetails', id, data);
        if (data && selectedTabData.personalData && selectedTabData.personalData.customerData) {
            data.customer = selectedTabData.personalData.customerData;
        }
        
        setDataForClaimAdd(data);
        setPopUpTitle('תביעה')
        setPopUpContent('');
        setShowAddClaimPopup(true);
    }
    const hideAddClaimPopup = () => {
        setShowAddClaimPopup(false);
        setPopUpTitle('תביעה עודכנה בהצלחה')
        setPopUpContent('');
        setShowPopup(true);
    }

    const cancelAddClaimPoopup = () => {
        setShowAddClaimPopup(false);
        setPopUpTitle('')
        setPopUpContent('');
    }

    const deleteApprovedCustomer = () => {
        if (customerIdForDelete) {
            deleteCustomer(customerIdForDelete);
        }
        const newFilter = filter;
        newFilter.filterSearch.searchText = searchText;
        setFilter(newFilter);
        // loadCustomers(newFilter);
        refreshClientList();
        hideApproveDelete();
    }
    
    const openPromptPopUp = (promptText: string, propmptTitle: string) => {
        // this.setState({
        // promptContent: promptText,
        // promptTitle: propmptTitle
        // });
    }

    
    // Policy Edit popup nd

    // Treatments popups
    
    const showAddTreatmentPopup = (type: number) => {
        setNewTreatmentType(type);
        setShowAddTreatmentPopup(true);
    }
    const showHideAddTreatmentPopup = (show: boolean) => {
        setShowAddTreatmentPopup(show);
    }
    
    function showTreatmentConfigPopup() {
        setShowTreatmentConfigPopup(true)
    }
    function hideTreatmentConfigPopup() {
        setShowTreatmentConfigPopup(false)
    }
    // Treatments popups end 
    
    // dcument popup

    const displayClientDocument = (documentUrl: string | null) => {
        setClientDocumentUrl(documentUrl)
    }
    const hideClientDocument = () => {
        setClientDocumentUrl(null)
    }
    const closeMessagePopup= () =>{
        setMessageContent(null);
    }
    const showMessagePopup= (message: string) =>{
        if (message && message.length > 0) {
            setMessageContent(message);
        }
    }

    const onClose = () => {
        setPopupShow(false);
    }

    const showPopUpMessage = (message: string) => {
        setMessege(message);
        setPopupShow(true);
    }

    // const showUploadDocument = (show: boolean, customerId: string) => {
    //     setShowModelUploadDocument({
    //         show: show,
    //         customerId: customerId
    //     });
    // }
    
    // documents end

    return (
        <div className="main-content clients-main-content rtl">


            {popupShow &&
                <MessegePopup
                    message={message}
                    statusMessege='success'
                    show={popupShow}
                    onClose={onClose}
                
                />
            }

            {
                showPopUp && 
                <ClientPopup
                    messageContent={popUpContent}
                    messageTitle={popUptitle}
                    ShowHidePopup={showHidePopup}
                    ClosePopup={()=>showHidePopup(false)}
                />
            }
            {
                showAddTreatmentPopUp && 
                <ClientAddTreatmentPopup
                    // messageTitle={newTreatmentType.toString()}
                    ShowHidePopup={showHideAddTreatmentPopup}
                    type={newTreatmentType}
                    ClosePopup={()=>showHideAddTreatmentPopup(false)}
                    customerId={sellectedCustomerId ? sellectedCustomerId : ''}
                    showPopUpMessage={showPopUpMessage}
                />
            }
            {
                showTreatmentConfigPopUp && 
                <ClientTreatmentTabConfigPopup
                    ClosePopup={hideTreatmentConfigPopup}
                    config={{}}
                    messageTitle={'הגדרות'}
                />
            }
            {
                showApprovePopup && 
                <ClientPopup
                    messageContent={popUpContent}
                    messageTitle={popUptitle}
                    approveBtnTitle={'מחק'}
                    ShowHidePopup={hideApproveDelete}
                    ClosePopup={hideApproveDelete}
                    OnApprove={deleteApprovedCustomer}
                />
            }
            {showAddClaimPopup && 
            <AddClaimPopup
                policyData= {dataForClaimAdd}
                ClosePopup={hideAddClaimPopup}
                showMessagePopup = {(message: string)=> showMessagePopup(message)}
                showAddTreatmentPopup={showAddTreatmentPopup}
                customerId={sellectedCustomerId ? sellectedCustomerId : ''}
                cancelAddClaimPoopup={cancelAddClaimPoopup}
                />
            }
            
            {
                clientDocumentUrl!=null?
                    (
                    <ClientDocumentPopup
                        ClosePopup={hideClientDocument}
                        documentUrl={clientDocumentUrl}
                    />
                    ):""
            }
            {
                loading && (
                    <PleaseWaitLayer />
                )
            }
            { messageContent &&
                <LeadMessagePopup
                    ClosePopup={() => closeMessagePopup()}
                    messageTitle={'שגיאה'}
                    messageContent={messageContent}
                />
            }

            
            {
                !userLogged && <LoginPopup />
            }
            <Menu activePage='Clients' />
            <div className="center-content">
                <Header PageName="ניהול לקוחות" />
                
                <section className="page-tab-row">
                    <div className="clents-tab-row-container">
                        <div className="emails-tab-row">
                            <div className={`email-tab email-tab-clients ${sellectedCustomerId == null ? 'selected' : ''}`} onClick={emptyFunc}>
                                <div className="top-border"></div>
                                <div className="tab-content">
                                    <div className="label" onClick={showClientSList}>
                                        רשימת לקוחות
                                    </div>
                                </div>
                            </div>
                            {openTabs.map((m:any) => {
                                return (
                                    <div className={`email-tab email-tab-view-message email-tab-${m.id} ${sellectedCustomerId == m.id ? 'selected' : ''}`} key={m.id}>
                                        <div className="top-border"></div>
                                        <div className="tab-content">
                                            <div className="label" onClick={()=>showClientTab(m.id)}>
                                                <b>{m.title}</b>
                                            </div>
                                            <div className="icon-holder pointer">
                                                <div className="icon x-close-grey" onClick={(e:any) => closeTab(m.id, e)}></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            {/* <div className="email-tab email-tab-view-message"><div className="top-border"></div><div className="tab-content"><div className="label">מסך חידושים</div><div className="icon-holder pointer"><div className="icon x-close-grey"></div></div></div></div> */}
                        </div>
                    </div>
                </section>
                <section className={`page-tab-content all-clients ${sellectedCustomerId == null ? 'selected' : ''}`} id="all-clients">
                    <div className="content-header">
                        <div className="flex-end desktop-only clients-search-row client-list-search client-list-view">
                            <div className="list-actions-row flex-centered flex-space-between">
                                <div className="filter-row flex-centered flex-space-between client-search">
                                    <div className="filter-input search">
                                        <Select
                                            style={{ width: '100%' }}
                                            value={searchProperty}
                                            onChange={setFilterParameter}
                                            options={
                                                [
                                                    {
                                                        label: 'חיפוש לפי פרמטר',
                                                        value: 'NONE'
                                                    },
                                                    {
                                                        label: 'ת.ז/ח.פ',
                                                        value: 'Identifier'
                                                    },
                                                    {
                                                        label: 'שם לקוח',
                                                        value: 'FullName'
                                                    },
                                                    {
                                                        label: 'טלפון',
                                                        value: 'Phones'
                                                    },
                                                    {
                                                        label: 'כתובת',
                                                        value: 'Address'
                                                    },
                                                    {
                                                        label: 'מס רישוי',
                                                        value: 'DriverLicenseNumber'
                                                    },
                                                    {
                                                        label: 'מס פוליסה',
                                                        value: 'PolicyNumber'
                                                    }                                                    
                                                ]
                                            }
                                        />
                                    </div>
                                    <div className="filter-input search">
                                        <input type="text" value={searchText ? searchText : ''}  placeholder="חיפוש" onChange={handleSearchChange}  />
                                        <div className="icon search"></div>
                                    </div>
                                    <div className="filter-input select">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder='חיפוש קבוצה'
                                            defaultValue={filter.group}
                                            value={filter.group}
                                            onChange={setFilterGroup}
                                            options={
                                                groups.map((g: any) => {
                                                    return {
                                                        label: g.name,
                                                        value: g.id
                                                    }
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="filter-input select">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="כל הסוכנים"
                                            defaultValue={filter.agent}
                                            value={filter.agent}
                                            onChange={setFilterAgent}
                                            options={
                                                agents.map((a: any) => {
                                                    return {
                                                        label: a.fullName,
                                                        value: a.id
                                                    }
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="filter-input select">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="כל המטפלים"
                                            defaultValue={filter.handler}
                                            value={filter.handler}
                                            onChange={setFilterHandler}
                                            options={
                                                handlers.map((h: any) => {
                                                    return {
                                                        label: h.fullName,
                                                        value: h.id
                                                    }
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="filter-button">
                                        <div className="icon refresh-counter" onClick={clearFilter}></div>
                                    </div>
                                </div>
                                <div className="cliets-main-buttons">
                                    <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={openNewCustomerTab}>
                                        <div className="icon add"></div>
                                        הוסף לקוח
                                    </button>
                                    <div className="icon icon-config gear"></div>
                                </div>
                            </div>
                            <div className="content-table-header flex-centered flex-space-between">
                                <div className="cell customer-status short">דירוג</div>
                                <div className="cell customer-status short">פוליסות</div>
                                <div className="cell customer-name status flex flex-top">
                                    שם
                                    {/* <div className="icon sort"></div> */}
                                </div>
                                <div className="cell customer-identificator">ח.פ / ת.ז</div>
                                <div className="cell customer-date customer-birth-date">תאריך לידה</div>
                                <div className="cell customer-age">גיל</div>
                                <div className="cell customer-email">אימייל</div>
                                <div className="cell customer-phone">טלפון</div>
                                <div className="cell customer-address">כתובת</div>
                                <div className="cell">סוכן</div>
                                <div className="cell">מטפל</div>
                                <div className="cell action"></div>
                            </div>
                        </div>
                    </div>
                    <div className="content-body client-list client-list-view">
                        {
                            clients.map((client: any, i: number)=>{
                                return (
                                    <ClientRow isAdmin={isAdmin} key={i} client={client} onSelect={()=>onRowSelect(client.id)} action={onCustomerAction} />
                                )
                            })
                        }
                    </div>
                    <footer className="footer emails-list-footer emails-list-view">
                        <Pagger pagerConf={pagerConf} changePage={changePage} refresh={emptyFunc}></Pagger>
                    </footer>
                </section>
                {sellectedCustomerId != null ? (
                    <section className={`page-tab-content ${sellectedCustomerId != null ? 'selected' : ''}`}>
                        <ClientDetails
                            customerId={sellectedCustomerId}
                            tabData={selectedTabData}
                            setLoading={setLoading}
                            updateEditData={updateTabEditData}
                            updateMode={updateTabMode}
                            setPopupShow={setPopupShow}
                            setMessege={setMessege}
                            onRowSelect={onRowSelect}
                            config={{
                                genders: genders,
                                martialStatuses: martialStatuses,
                                cities: citiesList,
                                closeTab: ()=>closeTab(sellectedCustomerId),
                                refresh: ()=>refreshClientList(),
                                ShowHidePopup: (show: boolean)=>showHidePopup(show),
                                showAddTreatmentPopup: (type: number)=>showAddTreatmentPopup(type),
                                showTreatmentConfigPopup: ()=>showTreatmentConfigPopup(),
                                hideTreatmentConfigPopup: ()=>hideTreatmentConfigPopup(),
                                displayClientDocument: displayClientDocument,
                                // showPolicyEditPopUpFunc: (val: boolean, type: string) => openPolicEditPopUp(val, type),
                                onClaimCreate: (id: string, data? :any) => onShowAddClaimPopup(id, data),
                                showMessagePopup: (message: string) => showMessagePopup(message),
                                // showUploadDocument: (show: boolean, customerId: string) => showUploadDocument(show, customerId)
                        }} />
                    </section>
                ) : (
                    <></>
                )
                }
                

            </div>
        </div>
      )
}

export default Clients;